// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const PieChartIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="PieChartIcon" ref={forwardedRef} {...props}>
      <path d="M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0m-1.62 1.25h-5.908l-2.383 4.965a6.5 6.5 0 0 0 8.29-4.965m.115-1.5a6.5 6.5 0 0 0-5.745-6.207V9.75zM9.25 3.543A6.501 6.501 0 0 0 6.715 15.61l2.535-5.28z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const PieChartIcon = /* @__PURE__ */ Object.assign(
  PieChartIconComponent,
  { displayName: 'PieChartIcon' },
);
